angular.module('components.caPurchaseOrderArticlesSummaryGrid', [])
    .component('caPurchaseOrderArticlesSummaryGrid', {
        templateUrl: 'main/order/purchaseorder/components/articlessummarygrid.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            articleIds: '=',
            purchaseOrder: '<',
            disabled: '<',
            orderChangeCount: '<',
            onArticleSelected: '&'
        },
        controller: controller
    });

// @ngInject
function controller($scope, $rootScope) {
    var vm = this;

    var articlesGrid = {};
    vm.articles = [];
    vm.articleIds = [];

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.currentUserClaims = $rootScope.currentUser.claims;
    vm.hasClaim = havePurchaseCostClaim();
    vm.captureArticlesGrid = captureArticlesGrid;
    vm.selectArticle = selectArticle;

    function onInit() {
        loadPurchaseOrderData();

        // To force the grid to redraw when the source items collection changes.
        // $scope.$watch(function() { return vm.articles.length; },
        //               function() {
        //                   refreshArticlesGrid();
        //               });

        // _.forEach(vm.purchaseOrder.orders, function(order) {
        //     // Put a listener on all orders' orderArticles
        //     $scope.$watch(function() { return order.orderArticles.length; },
        //                   function() {
        //                       updateAddedArticlesCollection();
        //                       refreshArticlesGrid();
        //                   });
        // });

        $scope.$watch(function() { return vm.orderChangeCount; }, function() {
            // updateAddedArticlesCollection();
            // refreshArticlesGrid();
            loadPurchaseOrderData();
        });

    }

    function onChanges() {
    }

    function onDestroy() {
    }

    function havePurchaseCostClaim(){
        if(vm.currentUserClaims.seepurchasecost === undefined){
           return false
        }

        if(!vm.currentUserClaims.seepurchasecost.read){
            return false
        }

        return true
    }

    // Short hand for creating the grid data, calculate quantities and forcing the grid to redraw.
    function loadPurchaseOrderData() {
        updateAddedArticlesCollection();
        recalculateArticleTotals();
        refreshArticlesGrid();
    }

    // Create a single list of articles for the grid to display.
    function updateAddedArticlesCollection() {
        vm.articles.length = 0;
        _.forEach(vm.purchaseOrder.orders, function(order) {
            _.forEach(order.orderArticles, function(orderArticle) {
                if (!_.find(vm.articles, function(article) { return article.id === orderArticle.article.id; })) {
                    vm.articles.push(orderArticle.article);
                    vm.articleIds.push({ articleId: orderArticle.article.id });
                }
            });
        });
    }

    function recalculateArticleTotals() {
        // Reset quantities
        _.forEach(vm.articles, function(addedArticle) {
            addedArticle['summarizedPurchaseCost'] = 0;
            addedArticle['summarizedSalesPrice'] = 0;
            addedArticle['summarizedQuantity'] = 0;
        });

        // Calculate article totals
        _.forEach(vm.articles, function(addedArticle) {
            _.forEach(vm.purchaseOrder.orders, function(order) {
                _.forEach(order.orderArticles, function(orderArticle) {
                    if (addedArticle.id === orderArticle.article.id) {
                        _.forEach(orderArticle.orderRows, function(orderRow) {
                            addedArticle['summarizedQuantity'] += orderRow.quantity;
                            addedArticle['summarizedPurchaseCost'] += orderRow.quantity * orderRow.purchaseCost;
                            addedArticle['summarizedSalesPrice'] += orderRow.quantity * orderRow.articleVariant.salesPrice;
                        });
                    }
                });
            });
        });
    }

    // Helper function. Calls refresh and invalidate on the grid if they have been defined (grid initialized)
    function refreshArticlesGrid() {
        if (articlesGrid.invalidate) {
            articlesGrid.invalidate();
        }
        if (articlesGrid.collectionView && articlesGrid.collectionView.refresh) {
            articlesGrid.collectionView.refresh();
        }
    }

    function captureArticlesGrid(s) {
        articlesGrid = s;
        refreshArticlesGrid();
    }

    function selectArticle(ar) {
        vm.onArticleSelected({article: ar});
    }
}
